<template>
    <fragebogen v-if="!submitted" :questions="block.fragen" :url="submitUrl"></fragebogen>
</template>

<script>
import Fragebogen from './Fragebogen';

export default {
    name: "FragebogenWrap",
    components: {
        'fragebogen': Fragebogen
    },
    data() {
        return {};
    },
    props: {
        block: {
            type: Object
        },
        seamless: {
            type: Boolean
        }
    },
    methods: {}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/subparts/FragebogenWrap.vue